import { render, staticRenderFns } from "./productList2.vue?vue&type=template&id=32b28ba2&scoped=true&"
import script from "./productList2.vue?vue&type=script&lang=js&"
export * from "./productList2.vue?vue&type=script&lang=js&"
import style0 from "./productList2.vue?vue&type=style&index=0&id=32b28ba2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b28ba2",
  null
  
)

export default component.exports